/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'

/**
 * Core scripts.
 */
import EventBus from '~/core/event-bus'
import Query from '~/core/query'

/**
 * Global Basis functions.
 */
window.basis = window.basis || {}
window.basis.EventBus = EventBus()
window.basis.Query = (query) => Query(query)

document.addEventListener('DOMContentLoaded', () => {
  // Add functions
})

/**
 * Custom components
 */
import HotspotsComponent from '~/components/hotspots'
customElements.define('hotspots-component', HotspotsComponent)

import VideoPlayer from '~/components/video-player'
customElements.define('video-player', VideoPlayer)

import BeforeAndAfter from '~/components/before-and-after'
customElements.define('before-and-after', BeforeAndAfter)

import ProductFormUpsell from '~/components/product-form-upsell'
customElements.define('product-form-upsell', ProductFormUpsell)
